import { safeSessionStorage } from "@/lib/storage/safe-storage";

export function recordUrlStateStorageKey(
  pathname: string,
  objectId: string,
  namespace?: string,
): string {
  return `record-url-state:${pathname}:${namespace ?? objectId}`;
}

export function clearStoredRecordUrlState(
  pathname: string,
  objectId: string,
  namespace?: string,
): void {
  safeSessionStorage().removeItem(
    recordUrlStateStorageKey(pathname, objectId, namespace),
  );
}
